/**
 * 'Roles Store'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
import BaseStore from '@/store/base-store'
const options = {}
export default new BaseStore('roles', options)



// WEBPACK FOOTER //
// ./src/store/roles/index.js